import { LOADING } from 'shared_js/constants/commonStatuses';

export default {
  mitraItems: [],
  loadingStatus: LOADING,
};
